import type { ProductId } from '../app-tile/app-selector/types';

/**
 * DnD "type" discriminators for ribbon drag payloads / drop targets.
 *
 * These are stored on Pragmatic DnD `source.data` / `dropTarget.data`.
 */
export enum RIBBON_DND_TILE_TYPE {
	APP_TILE = 'APP_TILE',
	HIDE_TILE = 'HIDE_TILE',
}

/**
 * DnD data for a draggable ribbon app tile.
 */
export type RibbonAppTileDndData = {
	index: number;
	productId: ProductId;
	type: typeof RIBBON_DND_TILE_TYPE.APP_TILE;
};

/**
 * DnD data for the footer "Hide" drop target.
 */
export type RibbonHideTileDndData = {
	type: RIBBON_DND_TILE_TYPE.HIDE_TILE;
};
